import { Stack } from '@mui/material';
import { EntitlementsContext } from 'Context/CompassRightsContext/EntitlementsProvider';
import { useContext, useEffect, useState } from 'react';
import { ClearFilters } from './ClearFilters';
import { Filters } from './Filters';
import { useIsDesktop } from 'Hooks';

export interface IFilteredCategories {
  id: number;
  name: string;
  checked: boolean;
  mainCategory: string;
  mainCategoryID: number;
}

export const SelectedFilters = () => {
  const { categories } = useContext(EntitlementsContext);
  const isDesktop = useIsDesktop();
  const [filteredCategories, setFilteredCategories] = useState<
    IFilteredCategories[]
  >([]);

  useEffect(() => {
    const tempFilteredCategories: IFilteredCategories[] = categories.flatMap(
      (category) =>
        category.subCategories
          .filter((subCategory) => subCategory.checked)
          .map((subCategory) => ({
            ...subCategory,
            mainCategory: category.name,
            mainCategoryID: category.id,
            checked: subCategory.checked || false,
          }))
    );
    setFilteredCategories(tempFilteredCategories);
  }, [categories]);

  return (
    <>
      {filteredCategories.length > 0 ? (
        <Stack
          width='100%'
          direction={isDesktop ? 'row' : 'column'}
          justifyContent='space-between'
          gap={isDesktop ? '0' : '40px'}
        >
          <Filters filteredCategories={filteredCategories} />
          {isDesktop && (
            <ClearFilters setFilteredCategories={setFilteredCategories} />
          )}
        </Stack>
      ) : null}
    </>
  );
};
